/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
    Row, Col, Collapse
} from "reactstrap"; 
import moment from "moment";
import Loader from "../../../loaders";
import api from "../../../../services/api";
import EditorSMS from "../EditorSMS";
import EditorEmail from '../EditorEmail';
import EditorComment from '../EditorComment';
import { TooltipButton } from '../../../inputs';

export default function Requests(props) {
    const {
        itemInEdit,
        itemInEdit: { candidateId, pinnedMessageLogId, firstLoadRequest },
        setItemInEdit,
    } = props;
    const [loading, setLoading] = useState(false);
    const [messageLogs, setMessageLogs] = useState([]);
    const [itemSMS, setItemSMS] = useState([]);
    const [itemEmail, setItemEmail] = useState([]);
    const [itemComment, setItemComment] = useState([]);
    const [pinnedMessageId, setPinnedMessageId] = useState(null);

    useEffect(() => {
        setPinnedMessageId(pinnedMessageLogId);
    }, [pinnedMessageLogId]);

    const loadMessageLogs = useCallback(() => {
        setLoading(true);
        setItemSMS([]);
        setItemEmail([]);
        setItemComment([]);

        api.get(`candidate/messagelogs/${candidateId}`)
            .then((response) => {
                const newLogs = response.data.map(d => ({...d, pinnedId: (d.messageLogId === (firstLoadRequest ? pinnedMessageLogId : pinnedMessageId)) ? d.messageLogId : 0}));
                newLogs.sort((a, b) => {
                    if (b.pinnedId !== a.pinnedId)
                        return b.pinnedId - a.pinnedId;

                    return b.sentDate - a.sentDate;
                });

                setMessageLogs(newLogs);
                setItemInEdit({...itemInEdit, firstLoadRequest: false});
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading(false));
    }, [itemInEdit, candidateId, firstLoadRequest, pinnedMessageLogId, pinnedMessageId]);

    useEffect(() => {
        if (!candidateId)
            return;

        loadMessageLogs();
    }, [candidateId]);

    useEffect(() => {
        if (firstLoadRequest || !candidateId)
            return;

        loadMessageLogs();
    }, [pinnedMessageId]);

    const pinMessage = useCallback((item) => {
        setLoading(true);

        api.get(`candidate/messagelog/pin/${candidateId}/${item.messageLogId}`)
            .then(() => {
                setPinnedMessageId(item.messageLogId);
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading(false));
    }, [candidateId]);

    const historyList = useMemo(() => {
        if (firstLoadRequest)
            return null;

        return messageLogs?.map((item, index) => {
            var dispatchUnitName = () => {
                var duName = item?.rosterCandidate?.roster?.dispatchUnit?.dispatchUnitName;
                if (duName) {
                    duName = duName.replace(/^(dispatch unit)/ig, "");
                    return `Dispatch Unit ${duName}`;
                }
                return null;
            }
    
            var sentToStatement = () => {
                if (item.notificationType == "Comment") {
                    return "";
                }
                else if (item.notificationType === 'Email') {
                    return ' Sent to ' + item.emailAddress;
                }
                else if (item.notificationType === 'SMS') {
                    return ' Sent to ' + item.mobilePhone;
                } else {
                    return ': ' + item.messageType?.lookupValue;
                }
            };
    
            return (
                    
                <li key={index} className="list-group-item">
                    <Row>
                        <Col xs={9} className="d-flex flex-wrap justify-content-start align-items-center">
                        {
                            (firstLoadRequest ? pinnedMessageLogId : pinnedMessageId) !== item.messageLogId ?
                            <TooltipButton
                                id={`pin_${item.messageLogId}`}
                                title="Pin this message"
                                className="mr-2 btn-icon"
                                color="default"
                                size="sm"
                                type="button"
                                outline
                                onClick={() => {
                                    pinMessage(item)
                                }}
                            >
                                <i className="fas fa-thumbtack" />
                            </TooltipButton>
                            :
                            <span className="mr-2 text-success">
                                <i className="fas fa-check mr-1" />Pinned
                            </span>
                        }
                            {item.sentDate && moment(item.sentDate).format("DD/MM/YYYY HH:mm:ss")}
                            <i className="ml-1 mr-1"></i> {item.notificationType} 
                            {sentToStatement()} <i className="ml-1 mr-1"></i> {dispatchUnitName()}
                        </Col>
                        <Col xs={3} className="text-right">
                            {item.createdBy}
                        </Col>
                    </Row>
                    <br />
                    <blockquote className="blockquote">
                        {
                            item.messageText ? <p className="mb-0">{item.messageText}</p>
                                : "<Empty>"
                        }
                    </blockquote>
                        </li>
            );
        })
    }, [messageLogs, pinnedMessageLogId, pinnedMessageId, firstLoadRequest, pinMessage]);

    return (
        <Row className="candidate-requests-container">
            <Col xs={12}>
                {loading && <Loader />}
                {!!itemSMS && itemSMS.length > 0 &&
                    <EditorSMS
                        items={itemSMS}
                        onClose={() => setItemSMS([])}
                        onSaved={() => loadMessageLogs()}
                        lookups={{
                            ...props.lookups
                        }}
                        defaultShowProjectAttribute={false}
                        showMessageTemplate={true}
                        sourcePage="candidate"
                    />
                }
                {
                    !!itemEmail && itemEmail.length > 0 &&
                    <EditorEmail
                        items={itemEmail}
                        onClose={() => setItemEmail([])}
                        onSaved={() => loadMessageLogs()}
                        lookups={{
                            ...props.lookups
                        }}
                        defaultShowProjectAttribute={false}
                    />
                }
                {
                    !!itemComment && itemComment.length > 0 &&
                    <EditorComment
                        items={itemComment}
                        onClose={() => setItemComment([])}
                        onSaved={() => loadMessageLogs()}
                        lookups={{
                            ...props.lookups
                        }}
                    />
                }
                <Collapse
                    isOpen={true}
                >
                    <TooltipButton
                        id="sendsms"
                        title="Send Bulk SMS"
                        className="btn-icon ml-2 mb-2"
                        color="default"
                        size="sm"
                        type="button"
                        onClick={() => {
                            setItemSMS([props.itemInEdit])
                        }}
                    >
                        <i className="fas fa-comment mr-1"></i> Send SMS
                    </TooltipButton>
                    <TooltipButton
                        id="sendemail"
                        title="Send Bulk Email"
                        className="btn-icon ml-2 mb-2"
                        color="default"
                        size="sm"
                        type="button"
                        onClick={() => {
                            setItemEmail([props.itemInEdit])
                        }}
                    >
                        <i className="fas fa-envelope-open"></i> Send Email
                    </TooltipButton>
                    <TooltipButton
                        id="addcomment"
                        title="Add Bulk Comment"
                        className="btn-icon ml-2 mb-2"
                        color="default"
                        size="sm"
                        type="button"
                        onClick={() => {
                            setItemComment([props.itemInEdit])
                        }}
                    >
                        <i className="fas fa-comment mr-1"></i> Add Comment
                    </TooltipButton>
                </Collapse>
            <Col xs={12}>
                <ul className="list-group list-group-flush">
                    {historyList}
                </ul>
                </Col>
            </Col>
        </Row>
    )
}
